import { definePreset, palette } from '@primeuix/themes'
import Nora from '@primeuix/themes/nora'

export const metroSpbPreset = definePreset(Nora, {
  semantic: {
    primary: palette('#0078C9'),
    colorScheme: {
      light: {
        primary: {
          color: '#0078C9',
          contrastColor: '#FFFFFF',
          hoverColor: '#0C5E98',
          activeColor: '#0A4E80',
        },
        highlight: {
          background: '#0078C9',
          focusBackground: '#0C5E98',
          color: '#FFFFFF',
          focusColor: '#FFFFFF',
        },
        surface: {
          0: '#ffffff',
          50: '#F4F8FB',
          100: '#E6F0F6',
          200: '#D3E2EC',
          300: '#B7CDDC',
          400: '#7E97A8',
          500: '#5E6A73',
          600: '#4A5862',
          700: '#2C3842',
          800: '#1A1C1E',
          900: '#121416',
          950: '#0B0D0F',
        },
      },
    },
  },
  components: {
    accordion: {
      panel: {
        borderWidth: '0',
      },
      header: {
        borderRadius: '0',
        borderWidth: '0 0 1px 0',
        borderColor: '{surface.200}',
        background: '{surface.50}',
        hoverBackground: '{surface.100}',
        activeBackground: '{surface.0}',
        activeColor: '{surface.800}',
        padding: '0.75rem 1rem',
        fontWeight: '600',
        focusRing: {
          width: '0',
          shadow: 'none',
        },
        first: {
          topBorderRadius: '0',
          borderWidth: '0 0 1px 0',
        },
        last: {
          bottomBorderRadius: '0',
          activeBottomBorderRadius: '0',
        },
        toggleIcon: {
          color: '{surface.500}',
          activeColor: '{surface.500}',
        },
      },
      content: {
        borderWidth: '0',
        padding: '1rem',
        background: '{surface.0}',
      },
    },
    datepicker: {
      dropdown: {
        background: '{surface.0}',
        borderColor: '{surface.200}',
        color: '{surface.500}',
        hoverBackground: '{surface.50}',
        hoverBorderColor: '{surface.200}',
        activeBackground: '{surface.100}',
        activeBorderColor: '{surface.200}',
        borderRadius: '4px',
        focusRing: {
          width: '0',
          shadow: 'none',
        },
      },
    },
  },
})
